import { render, staticRenderFns } from "./ProLists.vue?vue&type=template&id=69976706&scoped=true&"
import script from "./ProLists.vue?vue&type=script&lang=js&"
export * from "./ProLists.vue?vue&type=script&lang=js&"
import style0 from "./ProLists.vue?vue&type=style&index=0&id=69976706&lang=scss&scoped=true&"
import style1 from "./ProLists.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69976706",
  null
  
)

export default component.exports